<template>
    <v-container>
        <evaluation-statistics-student v-if="isStudent"/>
        <evaluation-statistics-team v-if="isTeam"/>
    </v-container>
</template>

<script>

import EvaluationStatisticsStudent from "@/components/coach/EvaluationStatisticsStudent";
import EvaluationStatisticsTeam from "@/components/coach/EvaluationStatisticsTeam";

export default {
    name: "EvaluationsStatistics",
    components: {EvaluationStatisticsTeam, EvaluationStatisticsStudent},
    computed: {
        type(vm = this) {
            return vm.$route.params.type
        },
        isStudent(vm = this) {
            return vm.type === 'student'
        },
        isGroup(vm = this) {
            return vm.type === 'group'
        },
        isTeam(vm = this) {
            return vm.type === 'team'
        }
    }
}
</script>

<style scoped>

</style>